import React from 'react';

import { useTranslation } from '@lt/localization';

import PackageRoomInfoContainer from './PackageRoomInfo';
import PackageMealInfoContainer from './components/PackageMealInfo';
import PackageFlightInfoContainer from './PackageFlightInfo';

import PackageInfoSkeleton from './PackageInfoSkeleton';
import type { IPackageInfo } from './types';

import styles from './packageInfo.module.css';

const PackageInfo = ({
  hasAdjustParams,
  isArchived,
  meal,
  mealCode,
  mealOriginal,
  operatorId,
}: IPackageInfo) => {
  const { t } = useTranslation();

  return hasAdjustParams ? (
    <PackageInfoSkeleton />
  ) : (
    <div className={styles.container}>
      <h2 className={styles.title}>
        {t('checkout.packageInfo.room.title_package')}
      </h2>
      <PackageRoomInfoContainer />
      <PackageMealInfoContainer
        meal={meal}
        mealCode={mealCode}
        mealOriginal={mealOriginal}
        operatorId={operatorId}
      />
      <PackageFlightInfoContainer isArchived={isArchived} />
    </div>
  );
};

export default PackageInfo;
